import { combineReducers } from 'redux';
import globalReducers from '@stores/global/reducers';
import { AUTH } from '@stores/auth/constants';
import authReducers from '@stores/auth/reducers';
import { DOCUMENT } from '@stores/document/constants';
import documentReducers from '@stores/document/reducers';
import { ERECRUITMENT } from '@stores/eRecruitment/constants';
import eRecruitmentReducers from '@stores/eRecruitment/reducers';
import { MY_PROFILE } from '@stores/myprofile/constants.js';
import myProfileReducers from '@stores/myprofile/reducers.js';
import { FEE } from '@stores/fee/constants.js';
import feeReducers from '@stores/fee/reducers.js';
import { CONTRACT } from '@stores/contract/constants';
import contractReducers from '@stores/contract/reducers';
import { K2_REPORT } from '@stores/k2Report/constants.js';
import k2ReportReducers from '@stores/k2Report/reducers.js';
import { PAYSLIP } from '@stores/payslip/constants';
import payslipReducers from '@stores/payslip/reducers';
import { ERECOGNITION } from '@stores/eRecognition/constants';
import eRecognitionReducers from '@stores/eRecognition/reducers';
import { CLIENT } from '@stores/client/constans.js';
import clientReducers from '@stores/client/reducers.js';
import { POLICY } from '@stores/policy/constants.js';
import policyReducers from '@stores/policy/reducers.js';
import { SALES_REPORT } from '@stores/salesReport/constants.js';
import salesReportReducers from '@stores/salesReport/reducers.js';
import leadReducers from '@stores/lead/reducers.js';
import { LEAD } from '@stores/lead/constants.js';
import { TRAJET_REPORT } from '@stores/trajetReport/constants.js';
import trajetReportReducers from '@stores/trajetReport/reducers.js';
import ePromotionReducers from '@stores/ePromotion/reducers.js';
import { EPROMOTION } from '@stores/ePromotion/constants.js';
import { EREQUEST } from '@stores/eRequest/constants.js';
import eRequestReducers from '@stores/eRequest/reducers.js';
import { OPM } from '@stores/opm/constants.js';
import opmReducers from '@stores/opm/reducers.js';

const rootReducer = combineReducers({
  globalReducers,
  [AUTH]: authReducers,
  [DOCUMENT]: documentReducers,
  [ERECRUITMENT]: eRecruitmentReducers,
  [EPROMOTION]: ePromotionReducers,
  [EREQUEST]: eRequestReducers,
  [CONTRACT]: contractReducers,
  [MY_PROFILE]: myProfileReducers,
  [FEE]: feeReducers,
  [K2_REPORT]: k2ReportReducers,
  [PAYSLIP]: payslipReducers,
  [ERECOGNITION]: eRecognitionReducers,
  [CLIENT]: clientReducers,
  [POLICY]: policyReducers,
  [SALES_REPORT]: salesReportReducers,
  [LEAD]: leadReducers,
  [TRAJET_REPORT]: trajetReportReducers,
  [OPM]: opmReducers,
});

export default rootReducer;
